import { useEffect } from 'react';
import { paintAppearance } from './appearance';
import { usePreferences } from './state/preferences';

/**
 * Keeps the document painted in what this person chose. The store is the
 * truth; this component is the brush, so every screen that changes a setting
 * — the customize panel, the settings page, a future server preference —
 * shows the result without knowing how the tokens are applied.
 */
export function AppearanceBridge() {
  const appearance = usePreferences((state) => state.appearance);
  const colorScheme = usePreferences((state) => state.colorScheme);

  useEffect(() => {
    void paintAppearance(appearance, colorScheme);
  }, [appearance, colorScheme]);

  return null;
}
